import {
  EThemes,
  IOrContentMediaBlockCSProps,
  TSpacing,
} from '@/lib/contentstack-sdk/types';
import { ReactNode } from 'react';

/**
 * Contentstack block shape for the OrContentMediaBlock component.
 * This wraps a single content block entry from the CMS.
 */
export type TOrContentMediaBlockCS = {
  block: IOrContentMediaBlockCSProps;
};

export enum EOrContentMediaBlockSize {
  SM = 'sm',
  LG = 'lg',
}

/**
 * Props for the OrContentMediaBlock  component.
 * Defines a two-column layout with customizable spacing, theme, and content.
 */
export interface IOrcontentMediaBlockProps {
  /** Elements rendered in the right-hand grid column */
  children: ReactNode;
  theme: EThemes;
  size: EOrContentMediaBlockSize;
  topSpacing?: TSpacing;
  bottomSpacing?: TSpacing;
  topDivider?: boolean;
  bottomDivider?: boolean;
  /** Function that returns the JSX for the left-hand content column */
  RenderLeftContent: () => ReactNode;
}
